import React from 'react';
import { RallyStateQuery } from '../../graphql-operations';
import Crayfish from './Crayfish';

type Entry = NonNullable<RallyStateQuery['rallyState']>['entries'][number];

type Props = {
  entries: Entry[];
  playerId?: string;
  ownProgress?: number;
};

export default function RaceTrack({ entries, playerId, ownProgress }: Props) {
  return (
    <div className="rally-track" aria-label="Kräftrallyts bana">
      <div className="rally-watermark">KRÄFT-RALLY</div>
      <div className="rally-finish-line" aria-hidden="true" />
      {entries.map((entry, index) => {
        const isSelf = entry.id === playerId;
        const progress =
          isSelf && ownProgress !== undefined ? ownProgress : entry.progress;
        const wave = Math.sin((progress / 100) * Math.PI * 4 + index * 0.75) * 0.42;
        const top = ((index + 0.55 + wave) / entries.length) * 100;
        return (
          <div
            className={`rally-racer${isSelf ? ' rally-racer--self' : ''}`}
            key={entry.id}
            style={{
              top: `${top}%`,
              left: `calc(5% + ${Math.min(progress, 100) * 0.9}%)`,
              zIndex: isSelf ? 3 : 2,
            }}
            title={`${entry.name}, ${entry.team}: ${progress}%`}
          >
            {isSelf && <span className="rally-self-marker">DU</span>}
            <Crayfish color={entry.teamColor} label={`${entry.name}s kräfta`} />
            <span className="rally-racer-name">{entry.name}</span>
          </div>
        );
      })}
    </div>
  );
}
